import { getBasePath } from '../../utils/config';
import {
  IarchiveHistoryAPIResponse,
  IconfirmUploadFileAPIResponse,
  IcreateAudienceAPIBody,
  IcreateAudienceAPIResponse,
  IcreateFilePatternAPIBody,
  IcreateFilePatternAPIResponse,
  IcreateMappingAPIBody,
  IcreateMappingAPIResponse,
  IcreateMappingFieldAPIBodyItem,
  IcreateMappingFieldAPIResponse,
  IcreatePointsOfSaleDictionaryAPIBodyItem,
  IcreatePointsOfSaleDictionaryAPIResponse,
  IdeleteMapAPIResponse,
  IdeleteMappingFieldAPIResponse,
  IdeletePointsOfSaleDictionaryAPIResponse,
  IgetAudiencesAPIResponse,
  IgetFilePatternsAPIResponse,
  IgetHistoryAPIBody,
  IgetHistoryAPIResponse,
  IgetMappingFieldsAPIResponse,
  IgetMappingsAPIResponse,
  IgetPointsOfSaleDictionaryAPIResponse,
  IreprocessImportAPIResponse,
  IrunDataPipelineAPIResponse,
  ItestMappingFusionAPIBody,
  ItestMappingFusionAPIResponse,
  ItestMappingLengthAPIBody,
  ItestMappingLengthAPIResponse,
  ItestMappingPatternAPIBody,
  ItestMappingPatternAPIResponse,
  IupdateAudienceAPIBody,
  IupdateAudienceAPIResponse,
  IupdateInboxFileEncodingAPIResponse,
  IupdateMappingAPIBody,
  IupdateMappingAPIResponse,
  IupdateMappingFieldAPIBody,
  IupdateMappingFieldAPIResponse,
  IupdatePointsOfSaleDictionaryAPIBody,
  IupdatePointsOfSaleDictionaryAPIResponse,
  IuploadFilesAPIBodyItem,
  IuploadFilesAPIResponse,
} from './dataIntegration.response.interface';

// HISTORY //////////////////////////////////////////////////////////////
export const getHistoryAPI = async ({
  body,
  token,
}: {
  body: IgetHistoryAPIBody;
  token: string;
}): Promise<IgetHistoryAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/upload_control/history`, params);
  const data = await response.json();
  return { response, data };
};

// AUDIENCES (superadmin) //////////////////////////////////////////////////////////
export const getAudiencesAPI = async ({
  token,
}: {
  token: string;
}): Promise<IgetAudiencesAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/audience/get_audience`, params);
  const data = await response.json();
  return { response, data };
};

export const createAudienceAPI = async ({
  body,
  token,
}: {
  body: Array<IcreateAudienceAPIBody>;
  token: string;
}): Promise<IcreateAudienceAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/audience/create_audience`, params);
  const data = await response.json();
  return { response, data };
};

export const updateAudienceAPI = async ({
  body,
  token,
}: {
  body: IupdateAudienceAPIBody;
  token: string;
}): Promise<IupdateAudienceAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/audience/update_audience`, params);
  const data = await response.json();
  return { response, data };
};

// MAPPING FIELDS (superadmin) //////////////////////////////////////////////////////////
export const getMappingFieldsAPI = async ({
  audienceId,
  token,
}: {
  audienceId: string | null;
  token: string;
}): Promise<IgetMappingFieldsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    audienceId
      ? `${getBasePath()}/csv_mapping/get_mapping_fields?audience_id=${audienceId}`
      : `${getBasePath()}/csv_mapping/get_mapping_fields`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const createMappingFieldAPI = async ({
  body,
  token,
}: {
  body: Array<IcreateMappingFieldAPIBodyItem>;
  token: string;
}): Promise<IcreateMappingFieldAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/create_mapping_fields`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const updateMappingFieldAPI = async ({
  body,
  token,
}: {
  body: IupdateMappingFieldAPIBody;
  token: string;
}): Promise<IupdateMappingFieldAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/update_mapping_fields`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const deleteMappingFieldAPI = async ({
  mappingFieldId,
  token,
}: {
  mappingFieldId: string;
  token: string;
}): Promise<IdeleteMappingFieldAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/delete_mapping_fields?id=${mappingFieldId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

// MAPPINGS ///////////////////////////////////////////////////////////////////////////7
export const getMappingsAPI = async ({
  brandId,
  token,
}: {
  brandId: string;
  token: string;
}): Promise<IgetMappingsAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brand_id: brandId,
    }),
  };
  const response = await fetch(`${getBasePath()}/csv_mapping/get_maps`, params);
  const data = await response.json();
  return { response, data };
};

export const createMappingAPI = async ({
  body,
  token,
}: {
  body: IcreateMappingAPIBody;
  token: string;
}): Promise<IcreateMappingAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/csv_mapping/map_csv`, params);
  const data = await response.json();
  return { response, data };
};

export const updateMappingAPI = async ({
  body,
  token,
}: {
  body: IupdateMappingAPIBody;
  token: string;
}): Promise<IupdateMappingAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/csv_mapping/update_csv_map`, params);
  const data = await response.json();
  return { response, data };
};

export const deleteMapAPI = async ({
  mapId,
  token,
}: {
  mapId: string;
  token: string;
}): Promise<IdeleteMapAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/delete_map?id=${mapId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const testMappingPatternAPI = async ({
  body,
  token,
}: {
  body: ItestMappingPatternAPIBody;
  token: string;
}): Promise<ItestMappingPatternAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/csv_mapping/pattern_mapping`, params);
  const data = await response.json();
  return { response, data };
};

export const testMappingLengthAPI = async ({
  body,
  token,
}: {
  body: ItestMappingLengthAPIBody;
  token: string;
}): Promise<ItestMappingLengthAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/csv_mapping/length_mapping`, params);
  const data = await response.json();
  return { response, data };
};

export const testMappingFusionAPI = async ({
  body,
  token,
}: {
  body: ItestMappingFusionAPIBody;
  token: string;
}): Promise<ItestMappingFusionAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/csv_mapping/fusion_mapping`, params);
  const data = await response.json();
  return { response, data };
};

// POINTS OF SALE DICTIONARY ////////////////////////////////////////////////////////////////
export const getPointsOfSaleDictionaryAPI = async ({
  clientId,
  token,
}: {
  clientId: string;
  token: string;
}): Promise<IgetPointsOfSaleDictionaryAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/get_point_of_sale?client_id=${clientId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const createPointsOfSaleDictionaryAPI = async ({
  body,
  token,
}: {
  body: Array<IcreatePointsOfSaleDictionaryAPIBodyItem>;
  token: string;
}): Promise<IcreatePointsOfSaleDictionaryAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/create_point_of_sale`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const updatePointsOfSaleDictionaryAPI = async ({
  body,
  token,
}: {
  body: IupdatePointsOfSaleDictionaryAPIBody;
  token: string;
}): Promise<IupdatePointsOfSaleDictionaryAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/update_point_of_sale`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const deletePointsOfSaleDictionaryAPI = async ({
  pointOfSaleDictionaryId,
  token,
}: {
  pointOfSaleDictionaryId: string;
  token: string;
}): Promise<IdeletePointsOfSaleDictionaryAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/delete_point_of_sale?id=${pointOfSaleDictionaryId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

// FILE PATTERNS /////////////////////////////////////////////////////////////////////////////
export const getFilePatternsAPI = async ({
  clientId,
  token,
}: {
  clientId: string;
  token: string;
}): Promise<IgetFilePatternsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/get_file_pattern?client_id=${clientId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const createFilePatternAPI = async ({
  body,
  token,
}: {
  body: IcreateFilePatternAPIBody;
  token: string;
}): Promise<IcreateFilePatternAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/create_file_pattern`,
    params
  );
  const data = await response.json();
  return { response, data };
};

// UPLOAD FILES
export const uploadFilesAPI = async ({
  body,
  token,
}: {
  body: Array<IuploadFilesAPIBodyItem>;
  token: string;
}): Promise<IuploadFilesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/upload/files`, params);
  const data = await response.json();
  return { response, data };
};

// export const uploadFileToS3API = async ({
//   file,
//   presigned_url,
// }: {
//   file: File;
//   presigned_url: string;
// }): Promise<Response> => {
//   const mediaBlob = await file.arrayBuffer();
//   const params = {
//     method: 'PUT',
//     body: new Blob([new Uint8Array(mediaBlob)], { type: file.type }),
//   };
//   const response = await fetch(presigned_url, params);
//   return response;
// };
export const uploadFileToS3API = async ({
  file,
  contentEncoding,
  presigned_url,
}: {
  file: File;
  contentEncoding: string;
  presigned_url: string;
}): Promise<Response> => {
  console.log({
    type: file.type,
    contentEncoding,
    presigned_url,
  });
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', file.type);
  myHeaders.append('Content-Encoding', contentEncoding);

  const params = {
    method: 'PUT',
    headers: myHeaders,
    body: file,
  };
  const response = await fetch(presigned_url, params);
  return response;
};

export const confirmUploadFileAPI = async ({
  key,
  token,
}: {
  key: string;
  token: string;
}): Promise<IconfirmUploadFileAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/upload/confirm_file_upload?key=${key}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const runDataPipelineAPI = async ({
  token,
}: {
  token: string;
}): Promise<IrunDataPipelineAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/upload/run_data_pipeline`, params);
  const data = await response.json();
  return { response, data };
};

export const reprocessImportAPI = async ({
  token,
  importId,
}: {
  token: string;
  importId: string;
}): Promise<IreprocessImportAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/reset_inbox_file?id=${importId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const updateInboxFileEncodingAPI = async ({
  inboxId,
  fileEncoding,
  token,
}: {
  inboxId: string;
  fileEncoding: string;
  token: string;
}): Promise<IupdateInboxFileEncodingAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: inboxId,
      file_encoding: fileEncoding,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/csv_mapping/update_inbox_file_encoding`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const archiveFileHistoryAPI = async ({
  importId,
  token,
}: {
  importId: string;
  token: string;
}): Promise<IarchiveHistoryAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/upload_control/history_archive?id=${importId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};
